export default __webpack_public_path__ + "img/76f3dde7f833ec7d771d6da5aff8b2fb.svg";